import { render } from "./label-shared.vue?vue&type=template&id=a78cf884&scoped=true"
import script from "./label-shared.vue?vue&type=script&lang=js"
export * from "./label-shared.vue?vue&type=script&lang=js"

import "./label-shared.vue?vue&type=style&index=0&id=a78cf884&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3423045755/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78cf884"]])

export default __exports__